import { Storage } from '@intelipost-js/secure-providers';

export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setNotifications(state, notifications) {
    state.notifications = notifications;
    return Storage.set(state.storageKey, notifications, 'session');
  },
};



// WEBPACK FOOTER //
// ./src/stores/notifications/mutations.js